/**
 * @owner @Appboy/messaging-experience
 */

/**
 * Whether the Knockout `selectedMessageTypes` `useEffect` should copy types
 * into Retry Window state.
 *
 * A Canvas message step can have two lists of selected channels:
 * - Knockout: `messageSelectorProps.selectedMessageTypes` (legacy composer)
 * - React: `MultiMessageComposer` when `canvas_granular_state_messages` is on
 *
 * When `canvas_granular_state_messages` is on, `MultiMessageComposer` already
 * reports the live selection through `onSelectedMessageTypesChange`. Copying
 * Knockout after that can replace Email+LINE with a stale Email-only list, and
 * the Retry Window looks eligible again. When the flipper is off, Knockout is
 * the only list, so there is nothing to overwrite with.
 *
 * @param isCanvasGranularStateMessagesEnabled - `canvas_granular_state_messages`
 * @returns False when `MultiMessageComposer` owns the channel list
 */
export const shouldApplyKnockoutSelectedTypesToRetry = (isCanvasGranularStateMessagesEnabled: boolean): boolean => {
  return !isCanvasGranularStateMessagesEnabled;
};
